var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraphql48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4081",
    d: "M24.5,45.161L7,34.82V14.18L24.5,3.839L42,14.18V34.82L24.5,45.161z M9,33.68l15.5,9.159L40,33.68 V15.32L24.5,6.161L9,15.32V33.68z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 5.5,
    r: 3.5,
    fill: "#ff4081"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 43.5,
    r: 3.5,
    fill: "#ff4081"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 33.5,
    r: 3.5,
    fill: "#ff4081"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 33.5,
    r: 3.5,
    fill: "#ff4081"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 3.5,
    fill: "#ff4081"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 15.5,
    r: 3.5,
    fill: "#ff4081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4081",
    d: "M42.72,35H6.28L24.5,2.978L42.72,35z M9.72,33H39.28L24.5,7.022L9.72,33z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql48);
export default __webpack_public_path__ + "static/media/graphql-48.255f0aab13d88a26a47558b41093107c.svg";
export { ForwardRef as ReactComponent };